<ng-template #errorsTemplate let-errors="errors">
  @if (errors) {
    @if (errors.pattern) {
      @if (regexMessage()) {
        <span [innerHTML]="regexMessage()"></span>
      } @else {
        <ng-container> Die Eingabe enthält ein unzulässiges Zeichen. </ng-container>
      }
    }
    @if (errors.required) {
      Bitte ergänze dieses Feld.
    }
    @if (errors.minlength) {
      Bitte ergänze dieses Feld mit einer Mindestlänge von
      {{ errors.minlength.requiredLength }} Zeichen.
    }
    @if (errors.maxlength) {
      Das Feld {{ fieldName() }} besitzt eine maximale Länge von
      {{ errors.maxlength.requiredLength }} Zeichen.
    }
    @if (errors.min) {
      Das Feld {{ fieldName() }} erfordert ein min. Wert von {{ errors.min.min | number: '1.0-0' }}.
    }
    @if (errors.max) {
      Das Feld {{ fieldName() }} hat den maximalen Wert von
      {{ errors.max.max | number: '1.0-0' }} überschritten.
    }
    @if (errors.email) {
      Das Feld {{ fieldName() }} muss eine gültige E-Mail-Adresse enthalten.
    }
    @if (errors.number) {
      Das Feld {{ fieldName() }} sollte eine Zahl sein.
    }
    @if (errors.url) {
      Die Eingabe {{ fieldName() }} sollte eine URL sein.
    }
    @if (errors.minStartOfContractDate) {
      Der Vertragsbeginn kann maximal 2 Monate rückdatiert werden.
    }
    @if (errors.minDate) {
      Das Datum muss am oder nach dem {{ errors.minDate?.value | date }} liegen.
    }
    @if (errors.maxDate) {
      Das Datum muss am oder vor dem {{ errors.maxDate?.value | date }} liegen.
    }
    @if (errors.minAge) {
      Muss mindestens {{ errors.minAge?.value }} oder älter sein.
    }
    @if (errors.matDatepickerFilter) {
      Das ausgewählte Datum ist nicht zulässig. Bitte wählen Sie ein anderes Datum.
    }
    @if (errors.date) {
      Das Feld {{ fieldName() }} sollte ein Datum sein (TT.MM.JJJJ).
    }
    @if (errors.userExists) {
      Der Nutzer ist nicht vorhanden.
    }
    @if (errors.uniqueQuantity) {
      Es gibt bereits eine Anzahloption mit der gleichen Menge.
    }
    @if (errors.contactInformationRequired) {
      Bitte ergänze das Feld. Bitte gib mindestens eine Kontaktinformation an.
    }
    @if (errors.invalidPhoneNumber) {
      Bitte gib eine gültige Telefonnummer ein. Gültig sind nur die folgenden Zeichen: "+", "0-9".
    }
    @if (errors.incompletePhoneNumber) {
      Bitte gib eine vollständige Telefonnummer ein. Erforderlich sind min. 6 Zeichen.
    }
    @if (errors.minSelectedRequired) {
      Du musst mindestens
      {{ errors.minSelectedRequired === 1 ? 'eine' : errors.minSelectedRequired }} Option wählen.
    }
    @if (errors.invalidPostalCode) {
      Bitte gib eine gültige Postleitzahl ein. Sie muss genau 5 Ziffern enthalten.
    }
    @if (errors.invalidEnumValue) {
      Bitte wähle eine gültige Option.
    }
    @if (errors.notMatch) {
      Die Eingabe stimmt nicht überein.
    }
    @if (errors.invalidInteger) {
      Die Eingabe muss eine ganze Zahl sein.
    }
    @if (errors.iban) {
      Ungültige IBAN.
    }
    @if (errors.custom) {
      {{ errors.custom }}
    }
    @if (errors.firstDayOfYear) {
      Das Datum darf nicht am 01.01. liegen
    }
    @if (errors.duplicateTarif) {
      Es dürfen keine doppelten Tarife vorhanden sein.
    }
    @if (errors.notDivisibleByX) {
      Der Wert muss durch {{ errors.notDivisibleByX.divider }} teilbar sein.
    }
    @if (errors.underageAtContract) {
      Muss mindestens 18 oder älter sein
    }
    @if (errors.notInList) {
      Die Saison muss mindestens 2 Monate und darf maximal 11 Monate dauern.
    }
  }
</ng-template>

<ng-container *ngTemplateOutlet="errorsTemplate; context: { errors: control()?.errors }" />

<!--dirty: {{ control.dirty }} - -->
<!--invalid: {{ control.invalid }}  - -->
<!--touched: {{ control.touched }} - -->
